<template>
  <div>
    <!-- {{this.$route.query}} -->
    <!-- 上课记录详细 -->
    <span class="systemFont1" style="margin-top: 35px">{{
      $t("p0332.classRecordDetails")
    }}</span>
    <el-row class="systemFont1" style="margin-top: 35px">
      <el-col :span="22" :offset="1" class="information">
        <!-- 编号 -->
        <span
          >{{ $t("p0322.numbering") }}：{{
            field + category + courseNumber
          }}</span
        >
        <!-- 课程名称 -->
        <span>{{ $t("p0322.courseTitle") }}：{{ courseName }}</span>
        <!-- 上课日期 -->
        <span v-if="formFlag"
          >{{ $t("p0322.classDates") }}：{{ formatClassDates() }}</span
        >
        <!-- 成绩模板导入 -->
        <span v-if="courseType !== '1'">
          <el-button type="p0332Button" plain @click="openDialog()">{{
            $t("p0332.gradeTemplateImport")
          }}</el-button>
          <el-dialog :visible.sync="dialogVisible" width="385px" center>
            <el-row style="text-align: center; margin-top: 15.3px">
              <el-col :span="12">
                <!-- 下载模板 -->
                <el-button type="p0322Button" @click="download()">{{
                  $t("p0332.downloadTemplate")
                }}</el-button>
              </el-col>
              <el-col :span="12">
                <!-- 上传模板 -->
                <el-upload
                  action="#"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="uploadTemplate"
                >
                  <el-button type="p0322Button">{{
                    $t("p0332.uploadTemplate")
                  }}</el-button>
                </el-upload>
              </el-col>
            </el-row>
          </el-dialog></span
        >
        <!-- 视频回放 -->
        <span v-if="formFlag && courseType !== '1'">
          <el-button
            type="p0332Button"
            plain
            @click="openRecordLink(false)"
            v-show="setRecordLinkForm.form !== '02' ? true : false"
            >{{ $t("p0332.setLinkCourseRecord") }}</el-button
          >
          <el-dialog
            class="dialogRecordLinkClass"
            :close-on-click-modal="false"
            :visible.sync="setRecordLinkVisible"
            :before-close="closeVideoLink"
            width="730px"
            center
          >
            <el-form
              :hide-required-asterisk="true"
              :model="setRecordLinkForm"
              ref="setRecordLinkRef"
              label-width="18%"
            >
              <div
                v-for="(item, index) in setRecordLinkForm.recordList"
                :key="index"
                style="width:100%;"
              >
                <!-- 表单 -->
                <el-col
                  :span="23"
                  style="border: 1px solid #CCCCCC;padding:10px 10px 0px 10px;margin-top:20px"
                >
                  <!-- 输入录像标题 -->
                  <el-form-item
                    :prop="'recordList.' + index + '.classVideoTitle'"
                    :rules="rules.classVideoTitle"
                    :label="$t('P0402.title')"
                  >
                    <el-input
                      v-model="item.classVideoTitle"
                      size="reportContentInput"
                      maxlength="64"
                    ></el-input>
                  </el-form-item>
                  <!-- 输入录像链接 -->
                  <el-form-item
                    :prop="'recordList.' + index + '.classVideoLink'"
                    :rules="rules.classVideoLink"
                    :label="$t('p0332.courseVideoLink')"
                    :key="'classVideoLink' + index"
                  >
                    <el-input
                      v-model="item.classVideoLink"
                      type="textarea"
                      size="reportLongContentInput"
                      :rows="4"
                      maxlength="360"
                    ></el-input>
                  </el-form-item>
                  <!-- 输入录像密码 -->
                  <el-form-item
                    prop="classVideoPw"
                    :label="$t('loginPage.passwordPlaceholder')"
                  >
                    <el-input
                      v-model="item.classVideoPw"
                      size="reportContentInput"
                      maxlength="20"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- 添加 -->
                <el-col :span="1">
                  <div
                    style="position: relative;float: right;top: 37px;display: flex;cursor: pointer;"
                  >
                    <span
                      v-if="index == 0"
                      style="width:30px;height:30px;display: flex;align-items: center;justify-content: center;"
                      @click="addInput()"
                    >
                      <img class="add-icon" src="@/assets/add.svg" />
                    </span>
                    <!-- 删除 -->
                    <span
                      v-if="index != 0"
                      style="width:30px;height:30px;display: flex;align-items: center;justify-content: center;"
                      @click="deleteInput(index)"
                    >
                      <img class="subtract-icon" src="@/assets/subtract.svg" />
                    </span>
                  </div>
                </el-col>
              </div>
            </el-form>

            <div slot="footer" style="text-align:center">
              <!-- 提交 -->
              <el-button type="submit" @click="submitVideoLink()">{{
                $t("p0332.submit")
              }}</el-button>
            </div>
          </el-dialog>
        </span>
        <!-- 下载二维码 -->
        <span v-if="formFlag && courseType !== '1'" class="VideoQrCodeClass">
          <el-button type="text" @click="dialogVideoQrCode = true">{{
            $t("p0332.downloadTheVideoQrCode")
          }}</el-button>
          <!-- 下载二维码 -->
          <el-dialog :close-on-click-modal="false" :visible.sync="dialogVideoQrCode" width="485px" center>
            <el-row style="text-align:center">
              <el-row>
                <!-- 视频回放 -->
                <el-col
                  style="font-size: 15px;text-align: right;height: 36px;line-height: 36px;"
                  :span="6"
                  >{{$t('p0332.setLinkCourseRecord')}}:</el-col
                >
                <!-- 二维码下载 -->
                <el-col :span="9">
                  <el-button
                    style="width: 100px;"
                    type="p0322Button"
                    @click="videoQrCode(0, true)"
                    >{{ $t("p0332.bt3") }}</el-button
                  ></el-col
                >
                <!-- 复制链接 -->
                <el-col :span="9">
                  <el-button
                    style="width: 100px;"
                    type="p0322Button"
                    @click="videoQrCode(0, false)"
                    >{{ $t("p0332.bt4") }}</el-button
                  ></el-col
                >
              </el-row>
              <el-row>
                <!-- 视频回放推广 -->
                <el-col
                  style="font-size: 15px;text-align: right;height: 36px;line-height: 36px;"
                  :span="6"
                  >{{$t('p0332.setLinkCourseRecord2')}}:</el-col
                >
                <!-- 下载视频回放推广二维码 -->
                <el-col :span="9">
                  <el-button
                    style="width: 100px;"
                    type="p0322Button"
                    @click="videoQrCode(1, true)"
                    >{{ $t("p0332.bt3") }}</el-button
                  ></el-col
                >
                <!-- 下载视频回放推广二维码 -->
                <el-col :span="9">
                  <el-button
                    style="width: 100px;"
                    type="p0322Button"
                    @click="videoQrCode(1, false)"
                    >{{ $t("p0332.bt4") }}</el-button
                  ></el-col
                >
              </el-row>
            </el-row>
          </el-dialog>
        </span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 27px">
      <el-col :span="22" :offset="1">
        <el-table
          ref="classRecordDetailsTable"
          :data="classRecordDetailsData"
          tooltip-effect="dark"
          style="min-width: 1500px"
          v-loading="tableLoading"
          @select="checkmark"
          @select-all="checkmark"
        >
          <!-- 选择框 -->
          <el-table-column v-if="courseType !== '1'" type="selection" :selected="true" min-width="10">
          </el-table-column>
          <!-- 姓名 -->
          <el-table-column
            :label="$t('p0322.name')"
            min-width="6"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.lastName + " " + scope.row.firstName
            }}</template>
          </el-table-column>
          <!-- 拼音_姓 -->
          <el-table-column
            prop="lastNameEn"
            :label="$t('p0332.pinyinSurname')"
            width="110px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.lastNameEn"
                v-if="courseType !== '1'"
                type="text"
                size="mini"
                maxlength="125"
                :DangerColor="scope.row.lastNameEnDanger"
                @blur="lastNameEnCheck(scope.row.lastNameEn, scope.$index)"
              />
              <span v-else>{{scope.row.lastNameEn}}</span>
            </template>
          </el-table-column>
          <!-- 拼音_名 -->
          <el-table-column
            prop="firstNameEn"
            :label="$t('p0332.pinyinName')"
            width="110px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.firstNameEn"
                v-if="courseType !== '1'"
                type="text"
                size="mini"
                maxlength="125"
                :DangerColor="scope.row.firstNameEnDanger"
                @blur="firstNameEnCheck(scope.row.firstNameEn, scope.$index)"
              />
              <span v-else>{{scope.row.firstNameEn}}</span>
            </template>
          </el-table-column>
          <!-- 邮箱 -->
          <el-table-column
            prop="email"
            :label="$t('p0332.mail')"
            min-width="14"
          >
          </el-table-column>
          <!-- 手机 -->
          <el-table-column
            prop="phone"
            :label="$t('p0332.cellPhone')"
            width="130px"
          >
            <template slot-scope="scope">{{
              scope.row.phoneArea + scope.row.phoneNo !== 0
                ? scope.row.phoneArea + scope.row.phoneNo
                : ""
            }}</template>
          </el-table-column>
          <!-- 公司 -->
          <el-table-column
            prop="existingCompany"
            :label="$t('p0332.company')"
            min-width="11"
          >
          </el-table-column>
          <!-- 职位 -->
          <el-table-column
            prop="position"
            :label="$t('p0332.position')"
            min-width="5"
            align="center"
          >
          </el-table-column>
          <!-- 内训授权员工 -->
          <el-table-column
            prop="isInternalTrainingAuthorized"
            :label="$t('p0332.isInternalTrainingAuthorized')"
            width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <span :style="scope.row.isInternalTrainingAuthorized === '1' ? '' : 'color:red'">{{ scope.row.isInternalTrainingAuthorized === '1' ? $t('p0332.yes') : $t('p0332.no') }}</span>
            </template>
          </el-table-column>
          <!-- 状态 -->
          <el-table-column
            prop="enterClassroomStatus"
            :label="$t('emailGroup.state')"
            width="70px"
            align="center"
          >
            <template slot-scope="scope"
              ><span
                :style="
                  scope.row.enterClassroomStatus == 0 ? 'color:#FF5454' : ''
                "
                >{{
                  scope.row.enterClassroomStatus == 0
                    ? $t("p0332.noLessons")
                    : $t("p0332.classesHaveBeenTaken")
                }}</span
              ></template
            >
          </el-table-column>
          <!-- 是否上课 -->
          <el-table-column prop="classStatus" width="150px" align="center" v-if="courseType !== '1'">
            <template #header>
              <el-col :span="12">
                <!-- 全部已经上课 -->
                <el-radio
                  v-model="whetherToAttendClass"
                  @change="attendClass"
                  label="attendClass"
                  ><span class="systemFont1">{{
                    $t("p0332.yes")
                  }}</span></el-radio
                >
              </el-col>
              <!-- 全部未上课 -->
              <el-col :span="12">
                <el-radio
                  v-model="whetherToAttendClass"
                  @change="noClass"
                  label="noClass"
                  ><span class="systemFont1">{{
                    $t("p0332.noClass")
                  }}</span></el-radio
                >
              </el-col>
            </template>
            <template slot-scope="scope">
              <el-col :span="12">
                <el-radio v-model="scope.row.classStatus" label="1">{{
                  $t("p0332.yes")
                }}</el-radio></el-col
              ><el-col :span="12">
                <el-radio v-model="scope.row.classStatus" label="0">{{
                  $t("p0332.no")
                }}</el-radio></el-col
              >
            </template>
          </el-table-column>
          <!-- 考核成绩 -->
          <el-table-column
            prop="examScore"
            v-if="courseType !== '1'"
            :label="$t('p0332.testScores')"
            width="100px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.examScore"
                :DangerColor="scope.row.examScoreDanger"
                type="text"
                size="mini"
                maxlength="15"
                @blur="examScoreCheck(scope.row.examScore, scope.$index)"
              />
            </template>
          </el-table-column>
          <!-- 是否通过 -->
          <el-table-column prop="passStatus" width="150px" align="center" v-if="courseType !== '1'">
            <template #header>
              <el-col :span="12">
                <!-- 全部通过 -->
                <el-radio v-model="whetherToPass" @change="pass" label="pass"
                  ><span class="systemFont1">{{
                    $t("p0332.yes")
                  }}</span></el-radio
                >
              </el-col>
              <!-- 全部未通过 -->
              <el-col :span="12">
                <el-radio
                  v-model="whetherToPass"
                  @change="didNotPass"
                  label="didNotPass"
                  ><span class="systemFont1">{{
                    $t("p0332.noPass")
                  }}</span></el-radio
                >
              </el-col>
            </template>
            <template slot-scope="scope">
              <el-col :span="12">
                <el-radio v-model="scope.row.passStatus" label="1">{{
                  $t("p0332.yes")
                }}</el-radio></el-col
              ><el-col :span="12">
                <el-radio v-model="scope.row.passStatus" label="0">{{
                  $t("p0332.no")
                }}</el-radio></el-col
              >
            </template>
          </el-table-column>
          <!-- 证书 -->
          <el-table-column
            prop="existingCompany"
            :label="$t('courseOption.certificate')"
            v-if="thirdPartyCert == '1' && courseType !== '1'"
            width="80px"
            align="center"
          >
            <template slot-scope="scope">
              <uploadFile
                :ref="scope.row.userId + 'uploadFile'"
                :uploadButtonStyle="1"
                :uploadFile="{
                  locationCode: scope.row.locationCode,
                  userId: scope.row.userId,
                  field: scope.row.field,
                  category: scope.row.category,
                  courseNumber: scope.row.courseNumber,
                  dateAndTime: scope.row.dateAndTime,
                  tqsUserId: scope.row.tqsUserId,
                  email: scope.row.email,
                  courseName: courseName,
                  uploadBtnDisplayFlag: true
                }"
              >
              </uploadFile>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <el-row style="text-align: right; margin-top: 10px">
      <el-col :span="22" :offset="1">
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[30, 50, 100]"
            :page-size="pageSize"
            layout="sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-row style="margin: 50px" v-if="courseType !== '1'">
      <el-col :span="4" :offset="10" style="margin-bottom: 50px">
        <el-col :span="12">
          <!-- 提交 -->
          <el-button type="submit" @click="submitDetailedClassRecord()">{{
            $t("p0332.submit")
          }}</el-button></el-col
        >
        <!-- 返回 -->
        <el-col :span="12"
          ><el-button type="return" @click="p0322Return()">{{
            $t("p0322.return")
          }}</el-button>
        </el-col>
      </el-col>
    </el-row>
    <el-row v-else style="margin: 50px">
      <el-col :span="4" :offset="10" style="margin-bottom: 50px">
        <!-- 返回 -->
        <el-col :span="24"
        ><el-button type="return" @click="p0322Return()">{{
            $t("p0322.return")
          }}</el-button>
        </el-col>
      </el-col>
    </el-row>
    <!-- 错误信息 -->
    <el-dialog
      class="dialogError"
      :visible.sync="listVisible"
      :title="$t('p0332.errorMessage')"
      width="560px"
      center
    >
      <el-table :data="errMsgList" style="margin-bottom: 75px">
        <el-table-column :show-header="false" align="center">
          <template slot-scope="scope">
            <span class="errdialog">{{ scope.row }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import uploadFile from "@/components/Common/UploadCertificate.vue";
import moment from "moment";
export default {
  components: {
    uploadFile
  },
  data() {
    let p0332 = JSON.parse(sessionStorage.getItem("p0332"));
    return {
      uploadFileShow: true,
      thirdPartyCert: "0",
      currentPage: 1,
      pageSize: 30,
      total: 0,
      formFlag: p0332.formCode !== "02",
      courseType: p0332.courseType,
      // 二维码弹窗
      dialogVideoQrCode: false,
      // 错误信息对话框是否显示
      listVisible: false,
      isdisabled: false,
      loaging: false,
      // 错误信息
      errMsgList: [],
      whetherToAttendClass: "",
      whetherToPass: "",
      // 表格加载
      tableLoading: false,
      // 表格数据
      classRecordDetailsData: [],
      checkClassRecordDetailData: [],
      //提交数据
      classInvitationVos: [],
      dialogVisible: false,
      field: p0332.field,
      category: p0332.category,
      courseNumber: p0332.courseNumber,
      courseName: p0332.courseName,
      dateAndTime: p0332.dateAndTime,
      endDateAndTime: p0332.endDateAndTime,
      thisroute: {},
      //录播链接弹框
      setRecordLinkForm: {
        // 上课录像链接
        classVideoLink: "",
        classVideoPw: "",
        recordList: [],
        form: ""
      },
      // 录播链接弹框是否显示
      setRecordLinkVisible: false,
      // 录播链接按钮是否显示
      recordLinkButtonShow: false,
      oldClassVideoLink: "",
      oldClassVideoPw: "",
      rules: {
        classVideoLink: [
          {
            required: true,
            message: this.$t("p0332.enterLinkRecord"),
            trigger: "blur"
          },
          {
            pattern: /^(http|https):\/\/([\w-]+\.)+[\w-]+(\/[\w-./#?%&=]*)?$/,
            message: this.$t("p0332.linkFormatIsIncorrect"),
            trigger: "blur"
          }
        ],
        classVideoTitle: [
          {
            required: true,
            message: this.$t("p0332.enterLinkTitle"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //判断更改页码是否需要查询
      if (
        this.classRecordDetailsData == undefined ||
        this.classRecordDetailsData.length <= 0
      ) {
        return;
      }
      this.selectInviteStudents();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val, flag) {
      this.currentPage = val;
      this.selectInviteStudents();
      console.log(`当前页: ${val}`);
    },
    // 下载视频二维码
    async videoQrCode(val, flag) {
      let length = await this.openRecordLink(true).then(result => result);
      if (length === 0) {
        this.$message.error(this.$t("p0332.msg1"));
        return;
      }
      // this.dialogVideoQrCode = false;
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/classRecord/videoQrCode";
      if (!flag) {
        url = "/api/classRecord/videoQrCodeLink";
        await this.$http
          .post(url, {
            field: this.field,
            category: this.category,
            courseNumber: this.courseNumber,
            dateAndTime: new Date(this.dateAndTime),
            qrCodeType: val
          })
          .then(rep => {
            this.$copyText(rep.data.data);
            loading.close();
            return this.$message.success(this.$t("复制成功"));
          })
          .catch(() => {});
      } else {
        this.$http
          .post(
            url,
            {
              field: this.field,
              category: this.category,
              courseNumber: this.courseNumber,
              dateAndTime: new Date(this.dateAndTime),
              qrCodeType: val
            },
            { responseType: "blob" }
          )
          .then(response => {
            console.log(
              "🚀 ~ file: P0332.vue:624 ~ videoQrCode ~ response:",
              response
            );
            // 文件名
            const fileName = this.courseName + this.dateAndTime + ".jpg";
            const fileStream = response.data; // 返回文件流
            const blob = new Blob([fileStream]);
            // 使用dom a 下载图片
            const a = document.createElement("a");
            const href = window.URL.createObjectURL(blob); // 创建下载连接
            a.href = href;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a); // 下载完移除元素
            window.URL.revokeObjectURL(href); // 释放掉blob对象
            loading.close();
          })
          .catch(err => {
            console.log(err);
            loading.close();
            this.$message.error(this.$t("common.anErrorOccurred"));
          });
      }
    },
    checkmark(selection, row) {
      row.checked = false;
      selection.forEach(item => {
        if (item === row) {
          row.checked = true;
        }
      });
    },
    checkmark(selection) {
      this.classRecordDetailsData.forEach(item => {
        item.checked = false;
      });
      selection.forEach(item => {
        item.checked = true;
      });
    },
    // 下载模板
    download() {
      this.dialogVisible = false;
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/classRecord/downloadTemplate";
      this.$http
        .get(url, { responseType: "blob" })
        .then(response => {
          // console.log("文件下载成功", response.data);
          const blob = new Blob([response.data]);
          console.log("blob", blob);
          this.formVisible = false;
          if (blob.size == 0) {
            this.$message.error(this.$t("p0211.existTemplate"));
            loading.close();
          } else {
            const fileName = "成绩模板.xls";
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
            loading.close();
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("p0211.errorTemplate"));
          loading.close();
        });
    },
    //上传模板
    uploadTemplate(file) {
      this.dialogVisible = false;
      if (!this.validationTemplate(file.raw)) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let templatefiles = new FormData();
      templatefiles.append("file", file.raw);
      templatefiles.append(
        "p0332",
        JSON.stringify({
          field: this.field,
          category: this.category,
          courseNumber: this.courseNumber,
          dateAndTime: this.dateAndTime,
          courseName: this.courseName,
          endDateAndTime: this.endDateAndTime,
          userId: localStorage.getItem("userId")
        })
      );
      let url = "/api/classRecord/uploadTemplate";
      this.$http
        .post(url, templatefiles)
        .then(response => {
          if (response.data.code === 200) {
            if (response.data.data !== null && response.data.data.length > 0) {
              this.selectInviteStudents();
              loading.close();
              this.errMsgList = response.data.data;
              this.listVisible = true;
            } else {
              this.selectInviteStudents();
              loading.close();
              setTimeout(() => {
                this.$message.success(this.$t("p0332.importSucceeded"));
              }, 0);
              setTimeout(() => {
                this.$message.success(this.$t("p0332.pageRefreshed"));
              }, 0);
            }
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },
    validationTemplate(file) {
      console.log(file);
      // 设置文件类型
      var i = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(i);
      const isXLS = i === "xlsx" || i === "xls";
      console.log(isXLS);
      if (!isXLS) {
        this.$message.error(this.$t("p0211.templateTypeErr"));
      }
      return isXLS;
    },
    fileCheck() {
      for (let index = 0; index < this.classInvitationVos.length; index++) {
        const element = this.classInvitationVos[index];
        if (this.$refs[element.userId + "uploadFile"].fileChanged) {
          return 1;
        }
      }
      return 0;
    },
    //提交
    async submitDetailedClassRecord() {
      this.classInvitationVos = this.$refs.classRecordDetailsTable.selection;
      //check
      if (this.classInvitationVos.length == 0) {
        // 未选择学员
        this.$message.error(this.$t("p0322.noStudentSelected"));
        return;
      }
      if (this.submitABugCheck(1) == 1) {
        //验证输入
        return;
      }
      if (this.unmodifiedCheck() === 0) {
        //判断重复
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      // 上传证书
      if (this.thirdPartyCert == "1") {
        for (let index = 0; index < this.classInvitationVos.length; index++) {
          const element = this.classInvitationVos[index];
          element.fileName = this.$refs[element.userId + "uploadFile"].name;
          await this.$refs[element.userId + "uploadFile"].submitUploadFile();
        }
      }
      let url = "/api/classRecord/submitClassRecord";
      this.$http
        .post(url, {
          userId: localStorage.getItem("userId"),
          field: this.field,
          category: this.category,
          courseNumber: this.courseNumber,
          dateAndTime: this.dateAndTime,
          classInvitationVos: this.classInvitationVos
        })
        .then(async response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            if (response.data.data === "1") {
              //该课程未绑定证书！请先绑定证书后再次尝试提交！
              this.$message.error(this.$t("p0332.thisCourseIsNot"));
              loading.close();
              return;
            }
            if (this.thirdPartyCert == "1") {
              this.uploadFileShow = false;
              this.uploadFileShow = true;
            }
            await this.selectInviteStudents();
            loading.close();
            //提交成功
            this.$message.success(this.$t("p0332.submittedSuccessfully"));
            this.$router.go(0);
          } else {
            this.tableLoading = false;
            this.$router.go(0);
            loading.close();

            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          loading.close();
          this.$message.error(err);
        });
    },
    //判断页面是否修改
    unmodifiedCheck() {
      let checkData = JSON.parse(this.checkClassRecordDetailData);
      for (let index = 0; index < checkData.length; index++) {
        if (this.classRecordDetailsData[index].checked) {
          if (
            this.classRecordDetailsData[index].firstNameEn !==
              checkData[index].firstNameEn ||
            this.classRecordDetailsData[index].lastNameEn !==
              checkData[index].lastNameEn ||
            this.classRecordDetailsData[index].examScore !==
              checkData[index].examScore ||
            this.classRecordDetailsData[index].classStatus !==
              checkData[index].classStatus ||
            this.classRecordDetailsData[index].passStatus !==
              checkData[index].passStatus
          ) {
            return 1;
          }
        }
      }
      //未修改
      if (this.thirdPartyCert == "1" && this.fileCheck() == 1) {
        return 1;
      }
      this.$message.error(this.$t("p0332.unmodified"));
      return 0;
    },
    //验证输入
    submitABugCheck(val) {
      for (let index = 0; index < this.classRecordDetailsData.length; index++) {
        if (this.classRecordDetailsData[index].checked) {
          // if (
          //   this.lastNameEnCheck(
          //     this.classRecordDetailsData[index].lastNameEn,
          //     index,
          //     val
          //   ) == 1
          // ) {
          //   return 1;
          // }
          // if (
          //   this.firstNameEnCheck(
          //     this.classRecordDetailsData[index].firstNameEn,
          //     index,
          //     val
          //   ) == 1
          // ) {
          //   return 1;
          // }
          if (
            this.examScoreCheck(
              this.classRecordDetailsData[index].examScore,
              index
            ) == 1
          ) {
            return 1;
          }
        }
      }

      return 0;
    },
    //check
    examScoreCheck(str, index) {
      let rules = /^([0-9][0-9]*)+(\.[0-9]{1})?$/;
      // if (str === "" || str == null) {
      //   this.classRecordDetailsData[index].examScoreDanger = "danger";
      //   setTimeout(() => {
      //     this.$notify.error({
      //       title: this.$t("common.error"),
      //       //成绩不能为空
      //       message: this.$t("p0332.gradesCannotBeEmpty"),
      //     });
      //   }, 0);
      //   return 1;
      // }
      if (!rules.test(str) && str !== "" && str != null) {
        this.classRecordDetailsData[index].examScoreDanger = "danger";
        setTimeout(() => {
          this.$notify.error({
            title: this.$t("common.error"),
            //只能输入数字
            message: this.$t("p0332.enterNumbersOnly")
          });
        }, 0);
        return 1;
      }
      this.classRecordDetailsData[index].examScoreDanger = null;
      return 0;
    },
    lastNameEnCheck(str, index, val) {
      let rules = /^[A-Za-z]+$/;
      if (val == 1) {
        if (str === "" || str == null) {
          this.classRecordDetailsData[index].lastNameEnDanger = "danger";
          setTimeout(() => {
            this.$notify.error({
              title: this.$t("common.error"),
              //姓不能为空
              message: this.$t("p0332.lastNameCannotBeEmpty")
            });
          }, 0);
          return 1;
        }
      }
      if (str !== "" && str != null && !rules.test(str)) {
        this.classRecordDetailsData[index].lastNameEnDanger = "danger";
        setTimeout(() => {
          this.$notify.error({
            title: this.$t("common.error"),
            //只能输入英文
            message: this.$t("p0332.englishOnly")
          });
        }, 0);
        return 1;
      }
      this.classRecordDetailsData[index].lastNameEnDanger = null;
      return 0;
    },
    firstNameEnCheck(str, index, val) {
      let rules = /^[A-Za-z]+$/;
      if (val == 1) {
        if (str === "" || str == null) {
          this.classRecordDetailsData[index].firstNameEnDanger = "danger";
          setTimeout(() => {
            this.$notify.error({
              title: this.$t("common.error"),
              //名不能为空
              message: this.$t("p0332.nameCannotBeEmpty")
            });
          }, 0);
          return 1;
        }
      }
      if (str !== "" && str != null && !rules.test(str)) {
        this.classRecordDetailsData[index].firstNameEnDanger = "danger";
        setTimeout(() => {
          this.$notify.error({
            title: this.$t("common.error"),
            //只能输入英文
            message: this.$t("p0332.englishOnly")
          });
        }, 0);
        return 1;
      }
      this.classRecordDetailsData[index].firstNameEnDanger = null;
      return 0;
    },
    //通过状态修改
    whetherPassStatus(val) {
      this.classRecordDetailsData.forEach(element => {
        element.passStatus = val;
      });
    },
    //上课状态修改
    whetherclassStatus(val) {
      this.classRecordDetailsData.forEach(element => {
        element.classStatus = val;
      });
    },
    //判断是否状态
    whether(val) {
      //是
      let yes = "1";
      //否
      let no = "0";
      switch (val) {
        case "pass":
          this.whetherPassStatus(yes);
          break;
        case "didNotPass":
          this.whetherPassStatus(no);
          break;
        case "attendClass":
          this.whetherclassStatus(yes);
          break;
        case "noClass":
          this.whetherclassStatus(no);
          break;
        default:
          break;
      }
    },
    //通过课程
    pass() {
      this.whetherToPass = "pass";
      this.whether(this.whetherToPass);
    },
    //未通过课程
    didNotPass() {
      this.whetherToPass = "didNotPass";
      this.whether(this.whetherToPass);
    },
    //已上课
    attendClass() {
      this.whetherToAttendClass = "attendClass";
      this.whether(this.whetherToAttendClass);
    },
    //未上课
    noClass() {
      this.whetherToAttendClass = "noClass";
      this.whether(this.whetherToAttendClass);
    },
    //格式化上课日期
    formatClassDates() {
      return moment(this.dateAndTime).format("YYYY-MM-DD HH:mm");
    },
    // 返回
    p0322Return() {
      this.$router.push({
        path: "/views/GreenJacketForum/P0331",
        query: {
          dateAndTime: this.$route.query.dateAndTime,
          courseName: this.$route.query.courseName,
          currentPageCo: this.$route.query.currentPageCo,
          totalCo: this.$route.query.totalCo,
          pageSizeCo: this.$route.query.pageSizeCo
        }
      });
    },
    // 打开dialog
    openDialog() {
      this.dialogVisible = true;
    },
    // 关闭dialog
    closeDialog() {
      this.dialogVisible = false;
    },
    // 初始化
    async selectInviteStudents() {
      this.tableLoading = true;
      let url = "/api/classRecord/selectClassRecordDetails";
      await this.$http
        .post(url, {
          field: this.field,
          category: this.category,
          courseNumber: this.courseNumber,
          dateAndTime: this.dateAndTime,
          currentPage: (this.currentPage - 1) * this.pageSize,
          pageSize: this.pageSize,
          total: this.total
        })
        .then(async response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            //初始化通过列
            if (response.data.data == null) {
              this.tableLoading = false;
              return;
            }
            response.data.data.forEach(element => {
              if (element.passStatus === "" || element.passStatus == null) {
                element.passStatus = "0";
              }
            });
            //写入表格数据
            this.classRecordDetailsData = response.data.data;
            if (response.data.data.length != 0) {
              this.setRecordLinkForm.classVideoLink =
                response.data.data[0].classVideoLink;
              this.setRecordLinkForm.classVideoPw =
                response.data.data[0].classVideoPw;
              this.setRecordLinkForm.form = response.data.data[0].form;
            } else {
              this.setRecordLinkForm.form = "01";
            }
            this.oldClassVideoLink = this.setRecordLinkForm.classVideoLink;
            this.oldClassVideoPw = this.setRecordLinkForm.classVideoPw;
            this.checkClassRecordDetailData = JSON.stringify(
              this.classRecordDetailsData
            );
            // 写入页码，是否第三方证书上传
            if (this.classRecordDetailsData.length > 0) {
              this.total = response.data.data[0].total;
              this.thirdPartyCert = response.data.data[0].thirdPartyCert;
            } else {
              this.thirdPartyCert = "0";
              this.total = 0;
            }
            if (this.thirdPartyCert == "1") {
              // 刷新上传组件
              for (
                let index = 0;
                index < this.classInvitationVos.length;
                index++
              ) {
                const element = this.classInvitationVos[index];
                await this.$refs[element.userId + "uploadFile"].init();
              }
            }
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
            if (this.thirdPartyCert == "1") {
              // 刷新上传组件
              for (
                let index = 0;
                index < this.classInvitationVos.length;
                index++
              ) {
                const element = this.classInvitationVos[index];
                await this.$refs[element.userId + "uploadFile"].init();
              }
            }
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          this.tableLoading = false;
          this.$message.error(err);
        });
    },
    // 打开视频回放dialog
    async openRecordLink(val) {
      let url = "/api/classRecord/selectRecordLink";
      return this.$http
        .post(url, {
          field: this.field,
          category: this.category,
          courseNumber: this.courseNumber,
          dateAndTime: moment(this.dateAndTime).format("YYYY-MM-DD HH:mm:ss")
        })
        .then(response => {
          if (val) {
            return response.data.data.length;
          }
          if (response.data.data.length == 0) {
            this.setRecordLinkForm.recordList = [];
            this.setRecordLinkForm.recordList.push({
              classVideoLinkTitle: "",
              classVideoLink: "",
              classVideoPw: ""
            });
          } else {
            this.setRecordLinkForm.recordList = response.data.data;
          }
          this.setRecordLinkVisible = true;
        })
        .catch();
    },
    // 录播课程弹框确定按钮
    submitVideoLink() {
      // 验证
      this.$refs.setRecordLinkRef.validate(valid => {
        if (valid) {
          this.setRecordLinkVisible = false;
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let url = "/api/classRecord/submitVideoLink";
          this.$http
            .post(url, {
              field: this.field,
              category: this.category,
              courseNumber: this.courseNumber,
              dateAndTime: this.dateAndTime,
              ...this.setRecordLinkForm,
              userId: localStorage.getItem("userId")
            })
            .then(response => {
              if (response.data.code === 200) {
                this.$message.success(this.$t("p0332.linkRecordSetSuccess"));
                this.closeVideoLink();
              } else {
                this.$message.error(response.data.message);
              }
              loading.close();
            })
            .catch(err => {
              loading.close();
              console.log(err);
            });
        }
      });
    },
    // 关闭录播课程弹框
    closeVideoLink() {
      // 表单重置
      this.$refs.setRecordLinkRef.resetFields();
      this.setRecordLinkVisible = false;
    },
    // 添加
    addInput() {
      this.setRecordLinkForm.recordList.push({
        classVideoLinkTitle: "",
        classVideoLink: "",
        classVideoPw: ""
      });
    },
    deleteInput(index) {
      this.setRecordLinkForm.recordList.splice(index, 1);
      this.$refs.setRecordLinkRef.clearValidate();
    }
  },
  mounted() {
    //初始化
    this.selectInviteStudents();
  },
  created() {}
};
</script>

<style lang="scss" scoped>
>>> .dialogError .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(80vh - 140px);
}
>>> .dialogError .el-table__header {
  border-bottom: 1px solid rgb(170, 170, 170);
}
>>> .dialogError .el-table th.el-table__cell.is-leaf {
  border-bottom: 0px solid rgb(170, 170, 170);
}
// 表格样式
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
  padding: 9.5px 0;
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-dialog__body {
  height: 90px;
}
.formItem2 >>> .el-form-item__label {
  line-height: 40px;
}
.dialogRecordLinkClass {
  //弹窗样式
  >>> .el-dialog__body {
    padding: 3px 30px;
    overflow-y: auto;
    height: calc(90vh - 140px);
  }
  >>> .el-dialog__body {
    height: 600px;
  }
  @media screen and (max-width: 1600px) {
    >>> .el-dialog__body {
      height: 400px;
    }
  }
  >>> .el-dialog__header {
    padding: 1px 20px 10px;
  }
  >>> .el-dialog__headerbtn {
    top: 12px;
  }
}
.information {
  text-align: right;
  min-width: 1500px;
  span {
    margin-left: 2%;
  }
}
.VideoQrCodeClass {
  .el-col {
    margin: 10px 0px;
  }
  >>> .el-dialog__body {
    height: 130px;
  }
  >>> .el-button--p0322Button {
    height: 36px;
    line-height: 36px;
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0332.vue